import React, { useEffect, useState } from 'react';

export default function ShieldMeter({ passRate }) {
  const [animated, setAnimated] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => setAnimated(passRate), 300);
    return () => clearTimeout(timer);
  }, [passRate]);

  const r = 72;
  const cx = 100, cy = 100;
  const circumference = 2 * Math.PI * r;
  const gapAngle = 60; // degrees gap at bottom
  const arcFraction = (360 - gapAngle) / 360;
  const arcLength = circumference * arcFraction;
  const dashOffset = arcLength - (arcLength * animated / 100);

  const color = passRate >= 90 ? '#00C2A8' : passRate >= 70 ? '#F5A623' : '#E8415A';
  const label = passRate >= 90 ? 'Protected' : passRate >= 70 ? 'Warning' : 'At Risk';

  // Rotation to start gap at bottom-left
  const rotation = 90 + gapAngle / 2;

  return (
    <div style={{ textAlign:'center' }}>
      <svg width="180" height="180" viewBox="0 0 200 200">
        {/* Track */}
        <circle
          cx={cx} cy={cy} r={r}
          fill="none"
          stroke="#1E2D4F"
          strokeWidth="10"
          strokeLinecap="round"
          strokeDasharray={`${arcLength} ${circumference}`}
          strokeDashoffset="0"
          transform={`rotate(${rotation} ${cx} ${cy})`}
        />
        {/* Progress */}
        <circle
          cx={cx} cy={cy} r={r}
          fill="none"
          stroke={color}
          strokeWidth="10"
          strokeLinecap="round"
          strokeDasharray={`${arcLength} ${circumference}`}
          strokeDashoffset={dashOffset}
          transform={`rotate(${rotation} ${cx} ${cy})`}
          style={{ transition: 'stroke-dashoffset 1.2s cubic-bezier(0.4,0,0.2,1), stroke 0.5s ease' }}
          filter={`drop-shadow(0 0 8px ${color}60)`}
        />

        {/* Shield icon in center */}
        <path
          d="M100 60L76 70V84C76 95.8 86.8 106.9 100 110C113.2 106.9 124 95.8 124 84V70L100 60Z"
          fill={`${color}20`}
          stroke={color}
          strokeWidth="1.5"
        />
        <path
          d="M93 85L98 90L109 79"
          stroke={color}
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />

        {/* Percentage */}
        <text x={cx} y={cy + 28} textAnchor="middle"
          fontFamily="Space Grotesk" fontWeight="700" fontSize="22"
          fill="#F0F4FF">
          {animated}%
        </text>
      </svg>

      <div style={{ fontFamily:'Space Grotesk', fontSize:'13px', fontWeight:600, color, letterSpacing:'1px', textTransform:'uppercase', marginTop:'-8px' }}>
        {label}
      </div>
      <div style={{ fontFamily:'Inter', fontSize:'11px', color:'#5B7BA8', marginTop:'4px' }}>
        DMARC Pass Rate
      </div>
    </div>
  );
}
